import { Button } from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import config from '$config';
import { useMaiaT } from '$app/i18n/useMaiaT';

const DivStyled = styled.div`
  background: #fff;
  padding: 8px 16px;
  margin: 0;
`;

const ButtonStyled = styled(Button)`
  background: none;
  border: none;
  box-shadow: none;
  margin: 0;
  font-weight: bold;
  color: #869096;
  font-size: 16px;
  text-shadow: none;
  border-radius: 0;
  position: relative;
  padding: 0;
  margin-right: 30px;

  .line {
    display: none;
    background: #3794fc;
    width: 100%;
    height: 4px;
    position: absolute;
    left: 50%;
    bottom: -10px;
    transform: translate(-50%, -50%);
    border-radius: 100px;
  }

  &.active,
  &:hover {
    color: #3794fc;
    border: none;
    background: none;
  }

  &.active {
    .line {
      display: block;
    }
  }
`;

export default function GarageEditMenu({ selectedItem, garageId, history }) {
  const t = useMaiaT();
  const isMotrio = config.segmentGroup === 'MOTRIO';

  return (
    <DivStyled>
      <ButtonStyled
        type="primary"
        onClick={e => {
          e.stopPropagation();
          history.push(`/${garageId}`);
        }}
        className={selectedItem === 'garageInfo' ? 'active' : ''}
      >
        {t('maia.garage.menu.garageInfo', 'Garage Info')}
        <span className="line" />
      </ButtonStyled>
      {!isMotrio && (
        <>
          <ButtonStyled
            type="primary"
            onClick={e => {
              e.stopPropagation();
              history.push(`/${garageId}/details`);
            }}
            className={selectedItem === 'details' ? 'active' : ''}
          >
            {t('maia.garage.menu.details', 'Garage Details')}
            <span className="line" />
          </ButtonStyled>
          <ButtonStyled
            type="primary"
            onClick={e => {
              e.stopPropagation();
              history.push(`/${garageId}/operations`);
            }}
            className={selectedItem === 'operations' ? 'active' : ''}
          >
            {t('maia.garage.menu.operations', 'Operations')}
            <span className="line" />
          </ButtonStyled>
          <ButtonStyled
            type="primary"
            onClick={e => {
              e.stopPropagation();
              history.push(`/${garageId}/coverage`);
            }}
            className={selectedItem === 'coverage' ? 'active' : ''}
          >
            {t('maia.garage.menu.coverage', 'Coverage')}
            <span className="line" />
          </ButtonStyled>
        </>
      )}
      <ButtonStyled
        type="primary"
        onClick={e => {
          e.stopPropagation();
          history.push(`/${garageId}/users`);
        }}
        className={selectedItem === 'users' ? 'active' : ''}
      >
        {t('maia.garage.menu.users', 'User Accounts')}
        <span className="line" />
      </ButtonStyled>
      <ButtonStyled
        type="primary"
        onClick={e => {
          e.stopPropagation();
          history.push(`/${garageId}/updates`);
        }}
        className={selectedItem === 'updates' ? 'active' : ''}
      >
        {t('maia.garage.menu.updates', 'Updates')}
        <span className="line" />
      </ButtonStyled>
      {!isMotrio && (
        <>
          <ButtonStyled
            type="primary"
            onClick={e => {
              e.stopPropagation();
              history.push(`/${garageId}/specialities`);
            }}
            className={selectedItem === 'specialities' ? 'active' : ''}
          >
            {t('maia.garage.menu.specialities', 'Specialities')}
            <span className="line" />
          </ButtonStyled>
          <ButtonStyled
            type="primary"
            onClick={e => {
              e.stopPropagation();
              history.push(`/${garageId}/capacity`);
            }}
            className={selectedItem === 'capacity' ? 'active' : ''}
          >
            {t('maia.garage.menu.capacity', 'Capacity')}
            <span className="line" />
          </ButtonStyled>
        </>
      )}
    </DivStyled>
  );
}

GarageEditMenu.propTypes = {
  selectedItem: PropTypes.string,
  garage: PropTypes.object,
  history: PropTypes.object,
};

GarageEditMenu.defaultProps = {
  selectedItem: '',
  garage: {},
  history: {},
};
